import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import styles from './LeftNavigationButton.module.scss';
import {
  selectPractitionerDoc24,
  userHasDOC24Permission as userHasDOC24PermissionSelector,
} from '../../../selectors/users';
import { createSessionDOC24Action } from '../../../actions/users/doc24';
import { DOC_24_TITLE } from '../../../constants/siteConstants';
import Loading from '../../Loading/Loading';
import GoogleTagManager from '../../../utils/googleTagManager';

const style = (b) => ({ backgroundImage: `url(${b})` });

const LeftNavigationButton = ({ href, title, tagManagerName, background, children }) => {
  const userHasDOC24Permission = useSelector(userHasDOC24PermissionSelector);
  const practitionerDoc24 = useSelector(selectPractitionerDoc24);
  const isLoading = useSelector((state) => state.loading.wait);

  const dispatch = useDispatch();

  const handleOnClick = (e) => {
    if (tagManagerName) {
      GoogleTagManager.sendButton(tagManagerName);
    }

    if (title === DOC_24_TITLE && userHasDOC24Permission) {
      e.preventDefault();
      dispatch(createSessionDOC24Action(practitionerDoc24));
    }
  };

  if (title === DOC_24_TITLE && !userHasDOC24Permission) return null;

  return (
    <Fragment>
      <li className={styles.datosIco}>
        <Link to={href} data-tip={title} style={style(background)} onClick={handleOnClick}>
          &nbsp;
        </Link>
        {children}
        <ReactTooltip place='right' effect='solid' />
      </li>
      {title === DOC_24_TITLE && isLoading && <Loading />}
    </Fragment>
  );
};

LeftNavigationButton.propTypes = {
  background: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default LeftNavigationButton;
